import React from 'react';

const NotFound = () => (
  <div style={{ margin: '10vh 0 0 0' }}>Not found.  Maybe there is a typo in the URL?</div>
)

export default NotFound;
